module.exports = __webpack_public_path__ + "static/media/angular.e23d7cd8.svg";